import turflineOverlap from "@turf/line-overlap";

export default function lineOverlap(source, target, options = {}) {
    return turflineOverlap(source, target, options);
}
